import "./pagination.scss";

import React from "react";
import { navigate } from "gatsby";
import ReactPaginate from "react-paginate";
import { useMediaQuery } from "react-responsive";

const Desktop = ({ current_page = 1, num_pages = 1, uri }) => {
  const handlePageClick = (e) => {
    if (e?.selected === 0) {
      navigate(`${uri}`);
    } else {
      navigate(`${uri}page/${e?.selected + 1}`);
    }
  };

  const isMediumScreen = useMediaQuery({
    query: "(max-width: 1250px)",
  });
  const isSmallScreen = useMediaQuery({
    query: "(max-width: 890px)",
  });

  const displayedRange = !!isSmallScreen ? 1 : !!isMediumScreen ? 5 : 10;

  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel={
        <img
          src={require("assets/icons/arrow-right--new.svg").default}
          alt=""
        />
      }
      className="pagination"
      onPageChange={handlePageClick}
      pageRangeDisplayed={displayedRange}
      marginPagesDisplayed={1}
      pageCount={num_pages}
      forcePage={current_page - 1}
      previousLabel={
        <img
          src={require("assets/icons/arrow-right--new.svg").default}
          alt=""
        />
      }
      renderOnZeroPageCount={null}
    />
    // <div className="pagination">
    //   {!isFirst && (
    //     <>
    //       <Link to={prevPage} className="pagination__prev">
    //         <img
    //           src={require("assets/icons/arrow-right--new.svg").default}
    //           alt=""
    //         />
    //       </Link>
    //       <div className="pagination__num-container">
    //         <Link to="/blog/" className="pagination__number">
    //           1
    //         </Link>
    //       </div>
    //       {current_page !== 2 && (
    //         <div className="pagination__num-container">...</div>
    //       )}
    //     </>
    //   )}
    //   {current_page !== 1 && current_page !== 2 && (
    //     <div className="pagination__num-container">
    //       <Link
    //         to={`${uri}page/${current_page - 1}/`}
    //         className="pagination__number"
    //       >
    //         {current_page - 1}
    //       </Link>
    //     </div>
    //   )}
    //   <div className="pagination__num-container">
    //     <div className="pagination__number pagination__number--current">
    //       {current_page}
    //     </div>
    //   </div>
    //   {current_page !== num_pages - 3 && current_page !== num_pages - 2 && (
    //     <div className="pagination__num-container">
    //       <Link
    //         to={`${uri}page/${current_page + 1}/`}
    //         className="pagination__number"
    //       >
    //         {current_page + 1}
    //       </Link>
    //     </div>
    //   )}
    //   {!isLast && (
    //     <>
    //       {current_page !== num_pages - 3 && (
    //         <div className="pagination__num-container">...</div>
    //       )}
    //       <div className="pagination__num-container">
    //         <Link
    //           to={`${uri}page/${num_pages - 2}/`}
    //           className="pagination__number"
    //         >
    //           {num_pages - 2}
    //         </Link>
    //       </div>
    //       <Link to={`${uri}page/${nextPage}/`} className="pagination__next">
    //         <img
    //           src={require("assets/icons/arrow-right--new.svg").default}
    //           alt=""
    //         />
    //       </Link>
    //     </>
    //   )}
    // </div>
  );
};

export default Desktop;
